module.exports = __webpack_public_path__ + "img/picture-loading-failed-1.4f4f66e1.png";